import BaseProxy from "../../base-proxy";

/**
 * @class UpdatePaymentRequestByTokenProxy
 * @description Class used for communicating GET payment request by token
 * @author Marco Chua
 * @version 1.0
 * @since March 03, 2020
 */
export default class UpdatePaymentRequestByTokenProxy {
  /**
   * @async
   * @function updateRecord
   * @param input - Input parameter instance.
   * @param {String} input - status to be updated
   * @param {String} data.authToken - Token used for issuing authenticated request.
   */
  async updateRecord(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/payment-requests/${input.paymentRequestId}`;

    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }
}
